import { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { LeaveReason } from '@tencent/wemeet-websdk-next';

import weMeetClient from '@utils/wemeetClient';
import { openDialog } from '@component/dialog';

/**
 * 在页面关闭的调用离开
 */
const usePageUnload = () => {
  // FIXME:
  // TODO: 目前看这段代码不会执行
  const onPopstate = () => {
    openDialog({
      title: <Translation>{(t) => t('离开会议')}</Translation>,
      content: <Translation>{(t) => t('即将离开当前会议')}</Translation>,
      btnConfigs: [
        {
          type: 'primary',
          text: <Translation>{(t) => t('确定')}</Translation>,
          callback: () => {
            leaveMeeting();
          },
        },
      ],
    });
  };

  const onBeforeUnload = () => {
    leaveMeeting();
  };

  const leaveMeeting = () => {
    if (weMeetClient.meetingCtrl.ifInMeeting()) {
      weMeetClient.meetingCtrl.leaveMeeting(LeaveReason.SELF);
    }
  };

  useEffect(() => {
    window.addEventListener('popstate', onPopstate);
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('popstate', onPopstate);
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);
};

export default usePageUnload;
